<template>
  <div>
    <h2 v-if="!value.length" class="text-center">ไม่มีข้อมูล</h2>
    <div v-for="(group, index) in value" :key="index" class="phone-group">
      <div class="text-end">
        <sc-button
          v-if="!disabled"
          variant="danger"
          class="btn-delete"
          @click="handleClickRemoveGroup(index)"
          >ลบกลุ่ม</sc-button
        >
      </div>
      <div class="row">
        <div class="col-9">
          <label class="label">ชื่อกลุ่ม</label>
          <el-input
            :value="group.group_title"
            :disabled="disabled"
            class="mb-3"
            type="text"
            @input="handleInputGroup(index, $event)"
          ></el-input>
        </div>
      </div>
      <div
        v-for="(contact, contactIndex) in group.contacts"
        :key="`${index}-${contactIndex}`"
        class="row mb-4 contact"
      >
        <div class="offset-2 col-4">
          <label class="label">ชื่อ</label>
          <el-input
            :value="contact.title"
            :disabled="disabled"
            type="text"
            @input="handleInputContact(index, contactIndex, 'title', $event)"
          ></el-input>
        </div>
        <div class="col-3">
          <label class="label">เบอร์ติดต่อ</label>
          <el-input
            :value="contact.phone_number"
            :disabled="disabled"
            type="text"
            @input="
              handleInputContact(index, contactIndex, 'phone_number', $event)
            "
          ></el-input>
        </div>
        <div class="col-3 text-end">
          <sc-button
            v-if="!disabled"
            variant="danger"
            class="btn-delete"
            @click="handleClickRemoveContact(index, contactIndex)"
            >ลบ</sc-button
          >
        </div>
      </div>
      <div v-if="!disabled" class="row">
        <div class="offset-4 col-5">
          <sc-button class="w-100" @click="handleClickAddContact(index)"
            >เพิ่ม</sc-button
          >
        </div>
      </div>
    </div>
    <div v-if="!disabled" class="row mt-4">
      <div class="col-6 offset-3">
        <sc-button
          class="w-100"
          variant="secondary"
          @click="handleClickAddGroup"
          >เพิ่มกลุ่ม</sc-button
        >
      </div>
    </div>
  </div>
</template>

<script>
import { Input } from "element-ui"
import ScButton from "@/lib/components/ScButton"

export default {
  components: {
    ElInput: Input,
    ScButton,
  },
  props: {
    value: {
      type: null,
      default: undefined,
    },
    disabled: {
      type: null,
      default: undefined,
    },
  },
  methods: {
    handleClickRemoveGroup(index) {
      this.$emit(
        "input",
        this.value.filter((_, i) => index !== i),
      )
    },
    handleClickRemoveContact(groupIndex, contactIndex) {
      this.$emit(
        "input",
        this.value.map((group, i) =>
          i === groupIndex
            ? {
                ...group,
                contacts: group.contacts.filter((_, ci) => ci !== contactIndex),
              }
            : group,
        ),
      )
    },
    handleClickAddContact(groupIndex) {
      this.$emit(
        "input",
        this.value.map((group, index) =>
          groupIndex === index
            ? {
                ...group,
                contacts: [...group.contacts, { title: "", phone_number: "" }],
              }
            : group,
        ),
      )
    },
    handleClickAddGroup() {
      this.$emit("input", [...this.value, { group_title: "", contacts: [] }])
    },
    handleInputGroup(index, event) {
      this.$emit(
        "input",
        this.value.map((group, i) =>
          i === index
            ? {
                ...group,
                group_title: event,
              }
            : group,
        ),
      )
    },
    handleInputContact(groupIndex, contactIndex, name, event) {
      this.$emit(
        "input",
        this.value.map((group, index) =>
          groupIndex === index
            ? {
                ...group,
                contacts: group.contacts.map((contact, cIndex) =>
                  cIndex === contactIndex
                    ? { ...contact, [name]: event }
                    : contact,
                ),
              }
            : group,
        ),
      )
    },
  },
}
</script>

<style lang="scss" scoped>
.contact .btn-delete {
  margin-top: 33px;
}

.phone-group {
  padding: 30px;

  &:nth-child(2n) {
    background: #ddd;
  }
}
</style>
